import React from "react";

export const LinkSlashIcon = ({ fill, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : 20}
      height={size ? size : 20}
      fill="none"
      viewBox="0 0 640 512"
    >
      <path
        fill={fill}
        d="M633.9 483.4C640.9 488.9 642 498.1 636.6 505.9C631.1 512.9 621 514 614.1 508.6L6.086 28.56C-.8493 23.08-2.033 13.02 3.443 6.086C8.918-.8493 18.98-2.033 25.91 3.443L633.9 483.4zM591.5 256L517.3 330.2L492 310.3L568.9 233.4C606.4 195.9 606.4 135.1 568.9 97.61C531.4 60.12 470.6 60.12 433.1 97.61L410.5 120.2C404.3 126.5 394.1 126.5 387.9 120.2C381.6 113.1 381.6 103.9 387.9 97.61L410.5 74.98C460.5 24.99 541.5 24.99 591.5 74.98C641.5 124.1 641.5 206 591.5 256L591.5 256zM286.2 380.6C259.1 353.5 246.6 317.1 249 281.5L282.4 307.8C285.8 326.2 294.6 343.8 308.8 357.9C328.7 377.8 355.2 387.2 381.2 385.9L414.6 412.2C370.7 425.9 320.9 415.3 286.2 380.6V380.6zM258.8 126.1L225.4 99.76C269.3 86.12 319.1 96.69 353.8 131.4C380.9 158.5 393.4 194.9 390.1 230.5L357.6 204.2C354.2 185.8 345.4 168.2 331.2 154.1C311.3 134.2 284.8 124.8 258.8 126.1V126.1zM71.1 278.6C33.61 316.1 33.61 376.9 71.1 414.4C108.6 451.9 169.4 451.9 206.9 414.4L229.5 391.8C235.7 385.5 245.9 385.5 252.1 391.8C258.4 398 258.4 408.1 252.1 414.4L229.5 437C179.5 487 98.46 487 48.47 437C-1.518 387-1.518 305.1 48.47 256L122.7 181.8L147.1 201.7L71.1 278.6z"
      />
    </svg>
  );
};
